import React from 'react';

import classNames from "classnames";
import styles from "../styles/betting-zone.drawer-menu.module.scss";
import {observer} from "mobx-react";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";
import {Clear} from "../../../../../core/icons/clear";
import {BettingZoneDrawerMenuBackButton} from "./betting-zone.drawer-menu.back-button";
import {BettingZoneDrawerMenuMainLogo} from "./betting-zone.drawer-menu.main-logo";
import {BETTING_CONTAINER} from "../../../betting-container-consts";

export const BettingZoneDrawerMenuHeader = observer(({
                                                       controller,
                                                       isMenuVisible,
                                                       setIsMenuVisible,
                                                       selectedItem,
                                                       setExpandedItemId,
                                                       expandedItemId,
                                                       navigate
                                                     }) => {
  const {state: {currentLinkModel}} = controller;
  const hasBackButton: Boolean = selectedItem !== null

  const clearButtonProps = {
    className: classNames(styles.clear_button),
    onClick: () => {
      const isSettingExpanded: Boolean = expandedItemId === 'settings';

      setIsMenuVisible(!isMenuVisible)
      controller.action(BETTING_CONTAINER.ACTION_TYPES.DRAWER_MENU.onOpenAndClose, {
        screen: currentLinkModel.params.slug || BETTING_CONTAINER.ANALYTICS.PAGES_CONTEXT_NAME[currentLinkModel.name],
        menuLevel: isSettingExpanded ? 2 : (expandedItemId ? 3 : (hasBackButton ? 2 : 1))
      })
      setExpandedItemId(null)
      navigate(-1)
    },
    style: {
      fill: useThemeColor(COLORS.textPrimary),
    }
  }

  const backButtonProps = {
    controller,
    navigate
  }

  return <div className={classNames(styles.header, {[styles.item_header]: hasBackButton})}>
    {
      hasBackButton ? <BettingZoneDrawerMenuBackButton {...backButtonProps}/> : <BettingZoneDrawerMenuMainLogo/>
    }
    {
      hasBackButton ? <div className={classNames(styles.header_title)}>{selectedItem.label}</div> : null
    }
    <Clear {...clearButtonProps}/>
  </div>
});
